import { render, staticRenderFns } from "./AutoCompleteObservations.vue?vue&type=template&id=100f1824&"
import script from "./AutoCompleteObservations.vue?vue&type=script&lang=js&"
export * from "./AutoCompleteObservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports